// Send a document to stakeholders by email through the worker (Resend), so
// there is a dated record of what was sent to whom — unlike a mailto: link,
// which leaves no trace in the app. Owner-only on the server.
export interface SentEmail {
  id?: string;
  to: string[];
  cc?: string[];
  subject: string;
  at: string;
  /** Attachment file names that went with it. */
  attachments?: string[];
}
export interface EmailDraft {
  to: string[];
  cc?: string[];
  subject: string;
  text: string;
  /** Ids of stored files (R2) to attach — e.g. the contractor's invoice. */
  fileIds?: string[];
  /** Inline attachments rendered on this device — e.g. the certificate PDF. */
  attachments?: { name: string; contentBase64: string }[];
}
export async function sendEmail(d: EmailDraft): Promise<SentEmail> {
  const r = await fetch("/api/email", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(d) });
  const body: any = await r.json().catch(async () => ({ error: await r.text().catch(() => "") }));
  if (r.status === 401) throw new Error("Sign in to send email.");
  if (!r.ok) throw new Error(body?.error || `Could not send (HTTP ${r.status}).`);
  return { id: body.id, to: body.to, cc: body.cc, subject: body.subject, at: body.at, attachments: body.attachments };
}
/** Base64 of a Blob's bytes (no data: prefix), for an inline attachment. */
export function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const fr = new FileReader();
    fr.onload = () => resolve(String(fr.result || "").replace(/^data:[^;]*;base64,/, ""));
    fr.onerror = () => reject(fr.error);
    fr.readAsDataURL(blob);
  });
}
/** Split a comma / semicolon / newline separated list of addresses. */
export function parseEmails(s: string): string[] {
  return Array.from(new Set(s.split(/[,;\s]+/).map((x) => x.trim().toLowerCase()).filter((x) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(x))));
}
